import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  isSessionLogOut: false,
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
    /**
   * 
   * Store axios response result 
   */
  SessionReload (state) {
      state.isSessionLogOut= false;
    },
  SessionOut (state) {
      state.isSessionLogOut= true;
    },
  /** set state */
  set (state, [variable, value]) {
    state[variable] = value
  },
  
}

const actions = { }

const getters = { }

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})